/**
 * Test IDs for QA automation.
 */
export const testIds = {
  viewDriverDetails: "view-driver-details",
  viewDriverOverview: "view-driver-overview",
  viewDriverPayment: "view-driver-payment",
  viewDriverRating: "view-driver-rating",
} as const;
